import { ActionReducerMap } from '@ngrx/store';
import { overviewOptionsReducer } from './overview';
import { overviewPageCacheReducer } from './overview-page-cache';
import { overviewStackReducer } from './overview-stack';
import { SharedApplicationState } from './shared-state';

export const sharedRootReducer: ActionReducerMap<SharedApplicationState> = {
    overviewOptions: overviewOptionsReducer,
    overviewPageCache: overviewPageCacheReducer,
    overviewStack: overviewStackReducer
};
